/* unplugin-vue-components disabled */import { render } from "./sh-topics.vue?vue&type=template&id=a5c9fcd6&scoped=true"
import script from "./sh-topics.vue?vue&type=script&lang=js"
export * from "./sh-topics.vue?vue&type=script&lang=js"

import "./sh-topics.vue?vue&type=style&index=0&id=a5c9fcd6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c9fcd6"],['__file',"src/pages/sh-topics/sh-topics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5c9fcd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5c9fcd6', __exports__)) {
    api.reload('a5c9fcd6', __exports__)
  }
  
  module.hot.accept("./sh-topics.vue?vue&type=template&id=a5c9fcd6&scoped=true", () => {
    api.rerender('a5c9fcd6', render)
  })

}


export default __exports__